module.exports = __webpack_public_path__ + "img/penalonen_hero_card.dec44c0b.png";